import $ from "jquery";
export function imagePopup() {
  $(document).ready(function() {
    $(".image-popup-no-margins").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: "mfp-no-margins mfp-with-zoom", // class to remove default margin from left and right side
      image: {
        verticalFit: true,
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
      },
    });
    $(".zoom-gallery").magnificPopup({
      preloader: true,
      delegate: "a",
      type: "image",
      alignTop: false,
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function(item) {
          return (
            item.el.attr("title") +
            ' &middot; <a class="image-source-link" href="'
          );
        },
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function(element) {
          return element.find("img");
        },
      },
    });
  });
}
